export default __webpack_public_path__ + "static/media/gallery38.0a0a62ca.jpg";